import { createSlice, createSelector, PayloadAction } from "@reduxjs/toolkit";
import { IStoreState } from "App/types";
import { LocalStorageService } from "shared/services";
import { IUnitType, ILocalStorageKey } from "shared/types";

export interface IUnitState {
  unitType: IUnitType;
  currency?: string; // todo euro, dollar etc.+
}

const initialState: IUnitState = {
  unitType: IUnitType.metric,
};

const unitSlice = createSlice({
  name: "units",
  initialState,
  reducers: {
    setUnitType: (state, { payload }: PayloadAction<IUnitType>) => {
      state.unitType = payload;
      LocalStorageService.setItem(ILocalStorageKey.unitType, payload);
    },
  },
});

export const unitTypeSelector = createSelector(
  (state: IStoreState) => state.units,
  (units) => units.unitType
);

export const { setUnitType } = unitSlice.actions;
export const unitReducer = unitSlice.reducer;
